  <template>
  <modal name="modal-introduce" class="modal-dialog" :draggable="true" :resizable="true">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-label">このページを紹介する</h4>
      </div>
      <div class="modal-body">
        <p>あなたの紹介コード: {{ $props.id }}</p>
        <textarea style="width: 100%;">【減災力テスト】紹介コードに{{ $props.id }}を入れてスタート! http://gensaikyoushitsu.sakura.ne.jp/</textarea>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" @click="$modal.hide('modal-introduce')">
          閉じる
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {
    props: [
      'id'
    ],
  }
</script>